import React from 'react';
import { alertError, alertSuccess } from '../config/toast';
import { getBannersReq, addBannerReq, updBannerReq, rmBannerReq, imgBase, getMasterCategoryReq } from '../config/httpRoutes';
import { Row, Form, Col, Card, Button, Image, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { defImg } from '../config/globals';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faPlus, faSpinner, faTrashAlt/* , faCamera */ } from '@fortawesome/free-solid-svg-icons';
import Loader from '../components/loader';
import TextInput from '../components/textInput';
import SelectInput from '../components/selectInput';
const bannerSections = ['advertisement', 'fruits', 'vegetables', 'groceries', 'last'];
const bannerBase = `${imgBase}banners/`;

class Banners extends React.Component {
	constructor(props) {
		super(props);

		this.imgInputRef = React.createRef();

		this.state = {
			banner_name: '',
			bnr: null,
			section: '',
			sequence: '',
			category_id: null, // Add state for master category ID
			banners: null,
			masterCategories: [], // Add state for master categories
			errors: { banner_name: '', section: '', sequence: '', category_id: null },
			loading: false,
			deleteLoading: false,
			fetchLoading: true,
			form: false,
			id: '',
		};
	}

	componentDidMount() {
		this.getBanners();
		this.getMasterCategories(); // Fetch master categories on component mount
	}

	getBanners = () => {
		this.setState({ fetchLoading: true });
		getBannersReq()
			.then((res) => {
				this.setState({ banners: res.data, form: false, bnr: '' });
			}).catch((err) => {
				alertError(err.response?.data?.msg || "Could not fetch banners");
			}).finally(() => {
				this.setState({ fetchLoading: false });
			});
	}

	getMasterCategories = () => {
		getMasterCategoryReq()
			.then((res) => {
				this.setState({ masterCategories: res.data });
			}).catch((err) => {
				alertError(err.response?.data?.msg || "Could not fetch master categories");
			});
	}

	rmBanner = (id, index) => {
		this.setState({ deleteLoading: true });
		rmBannerReq({ id })
			.then((res) => {
				const { banners } = this.state;
				banners.splice(index, 1);
				this.setState({ banners });
			}).catch((err) => {
				alertError(err.response?.data?.msg || "Could not remove banner");
			}).finally(() => {
				this.setState({ deleteLoading: false });
			});
	}

	handleChange = ({ target: { name, value } }) => {
		console.log(name, value);
		this.setState({ [name]: value });
	}

	validate = () => {
		const { banner_name, section, sequence, category_id } = this.state;
		let errors = { banner_name: '', section: '', sequence: '', category_id: null }, isValid = true;

		if (!section) {
			errors.section = "Enter section to continue";
			isValid = false;
		}
		if (!banner_name) {
			errors.banner_name = "Upload banner to continue";
			isValid = false;
		}
		if (!sequence) {
			errors.sequence = "Enter sequence to continue";
			isValid = false;
		}
		if (!category_id) {
			errors.category_id = "Select a category to continue";
			isValid = false;
		}

		this.setState({ errors });
		return isValid;
	}

	handleSubmit = (e) => {
		e.preventDefault();
		let { id, banner_name, section, sequence, bnr, category_id } = this.state;
		console.log("state", this.state);

		if (this.validate()) {
			if (id) {

				this.setState({ loading: true });
				const formData = new FormData();
				formData.append('id', id);
				formData.append('section', section);
				formData.append('sequence', sequence);
				formData.append('bnr', bnr);
				formData.append('banner_name', bnr ? bnr.name || `${section}_${sequence}.${bnr.type.split("/")[1]}` : banner_name);
				formData.append('category_id', category_id); // Add master category ID to form data
				updBannerReq(formData)
					.then((res) => {
						this.setState({ loading: false });
						alertSuccess("Banner updated");
						this.getBanners();
					}).catch((err) => {
						this.setState({ loading: false });
						alertError(err?.response?.data?.msg || err?.response?.data?.message || "Could not complete request");
					});
			} else {
				console.log("state", this.state);

				this.setState({ loading: true });
				const formData = new FormData();
				formData.append('section', section);
				formData.append('sequence', sequence);
				formData.append('bnr', bnr);
				formData.append('banner_name', bnr ? bnr.name || `${section}_${sequence}.${bnr.type.split("/")[1]}` : banner_name);
				formData.append('category_id', category_id); // Add master category ID to form data
				addBannerReq(formData)
					.then((res) => {
						this.setState({ loading: false });
						alertSuccess("Banner added");
						this.getBanners();
					}).catch((err) => {
						this.setState({ loading: false });
						alertError(err?.response?.data?.msg || err?.response?.data?.message || "Could not complete request");
					});
			}
		}
	}

	navigateAdd = () => {
		this.setState({ id: '', banner_name: '', section: '', sequence: '', errors: { banner_name: '', section: '', sequence: '' }, loading: false, form: true });
	}

	navigateEdit = (id, banner_name, section, sequence) => {
		this.setState({ id, banner_name, section, sequence, errors: { banner_name: '', section: '', sequence: '' }, loading: false, form: true });
	}

	onChangeFile = (e) => {
		if (e.target.files.length > 0) {
			let fileName = e.target.files[0].name;
			this.getBase64(e.target.files[0], (res) => {
				this.setState({ [e.target.name]: res, /* banner_name: fileName, */ bnr: e.target.files[0] });
			});
		}
	}

	getBase64 = (file, cb) => {
		let reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = function () {
			cb(reader.result)
		};
		reader.onerror = function (error) {
			console.log('Error: ', error);
		};
	}


	render() {
		const { id, bnr, banner_name, section, sequence, category_id, banners, masterCategories, deleteLoading, errors, loading, fetchLoading, form } = this.state;
		const { handleChange, handleSubmit, navigateAdd, navigateEdit, rmBanner, onChangeFile, imgInputRef } = this;

		// Ensure masterCategories is populated before rendering the form
		if (form && masterCategories.length === 0) {
			return <Loader />;
		}

		return (
			form ?
				<Row style={{ marginLeft: 0, marginRight: 0 }}>
					<Col md={{ span: 4, offset: 4 }} lg={{ span: 4, offset: 4 }} xs={12}>
						<Card style={{ marginTop: '20%' }}>
							<Card.Header>
								<Card.Title style={{ textAlign: 'center' }}>{id ? 'Update ' : 'Add '} Banner</Card.Title>
							</Card.Header>
							<Card.Body>
								<Form onSubmit={handleSubmit}>
									<Form.Group style={{ position: 'relative' }}>
										<Form.Control name="banner_name" onChange={onChangeFile} type="file" style={{ display: 'none' }} ref={imgInputRef} />
										{banner_name ?
											bnr ?
												<>
													<Image fluid style={{ marginLeft: '20%', width: '50%', height: 150, cursor: 'pointer' }} onClick={() => { imgInputRef.current.click() }} src={banner_name} />
													<button type="button" className="btn-success btn btn-circle" style={{ position: 'absolute', right: '25%', bottom: 0 }} onClick={() => { imgInputRef.current.click() }}>
														<FontAwesomeIcon icon={faPlus} />
													</button>
												</>
												:
												<>
													<Image fluid style={{ marginLeft: '25%', width: '50%', height: 150, cursor: 'pointer' }} onClick={() => { imgInputRef.current.click() }} src={`${bannerBase}${banner_name}`} />
													<button type="button" className="btn-success btn btn-circle" style={{ position: 'absolute', right: '25%', bottom: 0 }} onClick={() => { imgInputRef.current.click() }}>
														<FontAwesomeIcon icon={faPlus} />
													</button>
												</>
											:
											<>
												<Image fluid style={{ marginLeft: '25%', width: '50%', height: 150, cursor: 'pointer' }} src={defImg} />
												<button type="button" className="btn-success btn btn-circle" style={{ position: 'absolute', right: '25%', bottom: 0 }} onClick={() => { imgInputRef.current.click() }}>
													<FontAwesomeIcon icon={faPlus} />
												</button>
											</>
										}
									</Form.Group>

									<Form.Group>
										<TextInput onChange={handleChange} value={sequence} error={errors.sequence} name="sequence" label="Sequence" />
									</Form.Group>

									<Form.Group>
										<SelectInput onChange={handleChange} error={errors.section} value={section} name="section" label="Section" options={bannerSections} />
									</Form.Group>

									<Form.Group>
										<div>
											<label>Category:</label>
											<select value={category_id} name="category_id" onChange={handleChange}>
												<option value="">Select a Master Category...</option>
												{masterCategories.map((cat) => (
													<option key={cat.id} value={cat.id}>
														{cat.name}
													</option>
												))}
											</select>
										</div>
									</Form.Group>

									<Button variant="success" type="submit" style={{ marginLeft: '30%', width: '40%', marginTop: '25px' }} size="lg" disabled={loading}>
										{loading ?
											<FontAwesomeIcon icon={faSpinner} spin />
											:
											'Save'
										}
									</Button>
								</Form>
							</Card.Body>
						</Card>
					</Col>
				</Row>
				:
				<Row style={{ marginLeft: 0, marginRight: 0, paddingLeft: '10%', paddingRight: '10%', paddingTop: '5%' }}>
					<Col md={12} style={{ justifyContent: 'flex-end', display: 'flex', marginTop: '10px', marginBottom: '15px' }}>
						<Button variant="success" onClick={navigateAdd} size="md">
							<FontAwesomeIcon icon={faPlus} /> Add Banner
						</Button>
					</Col>
					{fetchLoading && <Loader />}
					{Array.isArray(banners) ?
						banners.length > 0 ?
							<div className="table-responsive">
								<table className="table table-hover table-attendance">
									<thead>
										<tr>
											<th>Banner</th>
											<th>Section</th>
											<th>Sequence</th>
											<th>Master Category</th>
											<th className="th1">Action</th>
										</tr>
									</thead>
									<tbody>
										{banners.map(({ id, banner_name, section, sequence, category_id }, i) =>
											<tr key={i}>
												<td>
													<Image fluid style={{ width: 50, height: 50 }} src={`${bannerBase}${banner_name}`} />
												</td>
												<td>{section}</td>
												<td>{sequence}</td>
												<td>{masterCategories.find(cat => cat.id === category_id)?.name || 'N/A'}</td>
												<td className="text-center">
													<div className="course-control-box icons-container d-flex">
														<OverlayTrigger overlay={<Tooltip>Edit</Tooltip>} delay={{ show: 150, hide: 150 }} >
															<FontAwesomeIcon icon={faEdit} className="disabled-icon font-16 cursor-pointer mr-3" onClick={(e) => { navigateEdit(id, banner_name, section, sequence, category_id) }} />
														</OverlayTrigger>
														<OverlayTrigger overlay={<Tooltip>Delete</Tooltip>} delay={{ show: 150, hide: 150 }}>
															<FontAwesomeIcon icon={faTrashAlt} className="disabled-icon font-16 cursor-pointer" onClick={(e) => { rmBanner(id, i) }} />
														</OverlayTrigger>
													</div>
												</td>
											</tr>
										)}
									</tbody>
								</table>
							</div>
							:
							<p style={{ position: 'fixed', marginLeft: '34%', marginTop: '20%' }}>No banners found.</p>
						:
						<></>
					}
				</Row>
		);
	}
}

export default Banners;